/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_TitleInputs */

const fr_legal_title = /** @type {(inputs: Legal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentions légales & Politique de confidentialité`)
};

const en_legal_title = /** @type {(inputs: Legal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal notice & Privacy policy`)
};

/**
* | output |
* | --- |
* | "Legal notice & Privacy policy" |
*
* @param {Legal_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_title = /** @type {((inputs?: Legal_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_title(inputs)
	return en_legal_title(inputs)
});